import React, {useEffect} from 'react';
import {useOpenApiFpRequest} from '../Http/useOpenApiRequest';
import {ArticleApi, ArticleDto, SystemApi} from '../scaffold';
import {Avatar, Card, Carousel, Col, List, Row, Space} from 'antd';
import './index.less';
import Marquee from 'react-fast-marquee';
import {Config} from '../config';
import Text from 'antd/lib/typography/Text';
import Paragraph from 'antd/lib/typography/Paragraph';
import moment from 'moment';
import Flex from '../components/Flex';
import classNames from 'classnames';

export default function IndexPage() {
  const partnersList = useOpenApiFpRequest(ArticleApi, ArticleApi.prototype.articleSearchGet);
  const summarizeList = useOpenApiFpRequest(ArticleApi, ArticleApi.prototype.articleSearchGet);
  const noticeList = useOpenApiFpRequest(ArticleApi, ArticleApi.prototype.articleSearchGet);
  const systemConfig = useOpenApiFpRequest(SystemApi, SystemApi.prototype.systemGetGet);

  useEffect(() => {
    partnersList.requestSync({catalogs: '团体会员风采', pi: 1, ps: 999});
    summarizeList.requestSync({catalogs: '会议活动总结', pi: 1, ps: 8});
    noticeList.requestSync({catalogs: '最新公告', pi: 1, ps: 8});
    systemConfig.requestSync({});
  }, []);

  function renderArticleItem(item: ArticleDto) {
    return (
      <Flex className={'ArticleListItem'} style={{padding: '8px'}} justify={'space-between'} onClick={() => window.open('/#/article/' + item.id, '_blank')}>
        <Space>
          <div className={item.catalogs === '最新公告' ? 'CircleDot' : 'SquareDot'} />
          <Text style={{width: item.catalogs === '最新公告' ? 200 : 270, marginRight: 10}} ellipsis>
            {item.title}
          </Text>
        </Space>
        {item.catalogs !== '最新公告' && <Text type={'secondary'}>[{moment(item.publishedDate).format('YYYY-MM-DD')}]</Text>}
        {item.catalogs === '最新公告' && (
          <Text type={'secondary'} style={{fontSize: 12}}>
            {moment(item.publishedDate).format('YY/MM/DD')}
          </Text>
        )}
      </Flex>
    );
  }

  return (
    <div className={'IndexPage'}>
      <Carousel className={'BannerCarousel'}>
        {systemConfig.data?.bannerImgPath01 && (
          <div>
            <div
              className={'BannerImg'}
              onClick={() => window.open(systemConfig.data?.bannerUrl01 || '', '_blank')}
              style={{
                backgroundImage: `url("${Config.ossPrefix + '/' + systemConfig.data?.bannerImgPath01}")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}></div>
          </div>
        )}
        {systemConfig.data?.bannerImgPath02 && (
          <div>
            <div
              className={'BannerImg'}
              onClick={() => window.open(systemConfig.data?.bannerUrl02 || '', '_blank')}
              style={{
                backgroundImage: `url("${Config.ossPrefix + '/' + systemConfig.data?.bannerImgPath02}")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}></div>
          </div>
        )}
        {systemConfig.data?.bannerImgPath03 && (
          <div>
            <div
              className={'BannerImg'}
              onClick={() => window.open(systemConfig.data?.bannerUrl03 || '', '_blank')}
              style={{
                backgroundImage: `url("${Config.ossPrefix + '/' + systemConfig.data?.bannerImgPath03}")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}></div>
          </div>
        )}
      </Carousel>
      <div className={'IndexPageContainer'}>
        <Row className={'m-b-20'}>
          <Col span={17}>
            <Card size={'small'} title={'会议活动总结'} extra={<a href={'/#/activity/summarize'}>更多</a>} loading={summarizeList.loading}>
              <Flex justify={'space-between'} align={'center'}>
                <Carousel style={{width: 380, height: 300}} dotPosition={'right'} autoplay autoplaySpeed={3000} effect={'fade'}>
                  {summarizeList.data?.list
                    ?.filter(i => !!i.coverPath)
                    .splice(0, 3)
                    .map(item => (
                      <div key={item.id} className={'SummarizeCover'} onClick={() => window.open('/#/article/' + item.id, '_blank')}>
                        <img src={Config.ossPrefix + '/' + item.coverPath} style={{width: 380, height: 300}} />
                        <div>
                          <Text style={{width: 350, color: 'white'}} ellipsis>
                            {item.title}
                          </Text>
                        </div>
                      </div>
                    ))}
                </Carousel>
                <List dataSource={summarizeList.data?.list || []} renderItem={renderArticleItem} />
              </Flex>
            </Card>
          </Col>
          <Col span={7}>
            <Card size={'small'} className={'m-l-20'} title={'最新公告'} loading={noticeList.loading} extra={<a href={'/#/notice/list'}>更多</a>}>
              <List dataSource={noticeList.data?.list || []} renderItem={renderArticleItem} />
            </Card>
          </Col>
        </Row>
        <Card title={'团体会员风采'} size={'small'} extra={<a href={'/#/partner/list'}>更多</a>} loading={partnersList.loading}>
          <Marquee style={{height: 300}} pauseOnHover speed={30}>
            {partnersList.data?.list?.map(item => (
              <div key={item.id} className={'Partner'} onClick={() => window.open('/#/article/' + item.id, '_blank')}>
                <div className={'PartnerLogo'}>
                  <img src={Config.ossPrefix + '/' + item.coverPath} alt="" />
                </div>
                <Text type={'secondary'}>企业会员</Text>
                <Paragraph style={{width: 180, fontSize: 16}} strong>
                  {item.title}
                </Paragraph>
              </div>
            ))}
          </Marquee>
        </Card>
      </div>
    </div>
  );
}
